<template>
  <div class="custom-field-cell">
    <div class="custom-field__prev">
      <slot name="prev"></slot>
    </div>
    <div class="custom-field__value" :style="isOpenEyeFunction ? 'padding: 0 1rem 0 0.4rem' : ''">
      <!--      <input-->
      <!--          class="custom-field__control"-->
      <!--          :type="type"-->
      <!--          :value="value"-->
      <!--          @input="handleInput"-->
      <!--          :placeholder="placeholder"-->
      <!--          :disabled="disabled"-->
      <!--      />-->
      <input
          class="custom-field__control"
          :type="internalType"
          :value="formattedValue"
          @input="handleInput"
          @focus="focus"
          @blur="blur"
          :placeholder="placeholder"
          :disabled="disabled"
          :maxlength="maxlength"
          ref="custom-field-input"
      />
      <template v-if="isOpenEyeFunction">
        <slot name="clear"></slot>
        <template v-if="bgColor == 'black-theme'">
          <img src="@/assets/images/icon_eye_close-dark.png" class="eye" v-show="!eyeIsOpen" @click="eyeSwitch">
          <img src="@/assets/images/icon_eye_open-dark.png" class="eye" v-show="eyeIsOpen" @click="eyeSwitch">
        </template>
        <template v-if="bgColor != 'black-theme'">
          <img src="@/assets/images/icon_eye_close.png" class="eye" v-show="!eyeIsOpen" @click="eyeSwitch">
          <img src="@/assets/images/icon_eye_open.png" class="eye" v-show="eyeIsOpen" @click="eyeSwitch">
        </template>
      </template>
    </div>
    <div class="custom-field__next">
      <slot name="next"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "customField",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: [String, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    openEyeFunction:{
      type: Boolean,
      default: false
    },
    formatter: {
      type: Function,
      required: false
    },
    maxlength: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    bgColor() { 
      return this.$store.getters["common/bgColor"];
    },
    isOpenEyeFunction() {
      return this.openEyeFunction && this.type === "password"
    },
    formattedValue() {
      // 使用 formatter 函数格式化内部值并返回
      return this.formatter ? this.formatter(this.rawValue) : this.rawValue;
    }
  },
  watch: {
    // 监听外部传入的 value 变化，确保与父组件保持同步
    value(newValue) {
      if (newValue !== this.rawValue) {
        this.rawValue = newValue;
      }
    }
  },
  data() {
    return {
      rawValue: this.value,
      internalType: "text",
      eyeIsOpen: false
    }
  },
  created() {
    this.openEyeFunctionHandle();
  },
  methods: {
    focus(){
      this.$emit("focus");
    },
    blur(){
      this.$emit("blur");
    },
    handleInput(e) {
      const value = e.target.value;
      this.rawValue = value;
      this.$emit("input", this.formattedValue);
    },
    eyeSwitch() {
      this.eyeIsOpen = !this.eyeIsOpen;
      if (this.eyeIsOpen) {
        this.internalType = "text";
      } else {
        this.internalType = "password";
      }
    },
    openEyeFunctionHandle(){
      this.internalType = this.type;
    },
    setInputFocus() {
      this.$refs['custom-field-input'].focus();
    }
  }
};
</script>

<style lang="less" scoped>
.custom-field-cell {
  display: flex;
  margin-bottom: 50px;
  background-color: #f6f6f6;
  border-radius: 10px;
  overflow: hidden;
}

.custom-field__prev {
  border-radius: 10px 0 0 10px;
}

.custom-field__value {
  flex: 1;
}

.custom-field__value {
  line-height: 80px;
  padding: 0 30px;
}

.custom-field__value {
  position: relative;

  .eye {
    position: absolute;
    right: 18px;
    top: 50%;
    margin-top: -25px;
    width: 50px;
    height: 50px;
    //background-color: #f6f6f6;
  }
}

.custom-field__control {
  height: 80px;
  width: 100%;
  font-size: 28px;
  background-color: #f6f6f6;
  border: none;
}
</style>
